import { render, staticRenderFns } from "./WorkDefaultTabIcon.vue?vue&type=template&id=05df59cf"
import script from "./WorkDefaultTabIcon.vue?vue&type=script&lang=js"
export * from "./WorkDefaultTabIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports